import styled from 'styled-components';

export const StyledCard = styled.div`
	display: flex;
	align-items: center;
	background-color: #fff;
	border-radius: 15px;
	box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px,
		rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
	margin: 40px 0;
	padding: 60px;
	flex-direction: ${({ layout }) => layout || 'row'};

	img {
		width: 80%;
		border-radius: 60px 15px;
		filter: grayscale(var(--value, 100%));
		opacity: 0.8;
	}

	& > div {
		flex: 1;
	}
	@media (max-width: ${({ theme }) => theme.mobile}) {
		flex-direction: column;
		text-align: center;
		padding-top: 40px;
	}
`;
